import { Component, OnInit, AfterViewInit } from "@angular/core";
import { CalendarOptions } from '@fullcalendar/core'; // useful for typechecking
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';

import { GoogleAuthService } from "../google-auth.service";
import { ApplicantStatusService } from "../services/Applicant-Status.service";

@Component({
  selector: "app-full-calendar",
  templateUrl: "./full-calendar.component.html",
  styleUrls: ["./full-calendar.component.scss"],
})

export class FullCalendarComponent implements OnInit {
  // calendarOptions: CalendarOptions;
  title = 'google-calendar';
  events: any[] = [];
  flag: boolean = false;

  isLoading = false;
  calLoad = false;
  constructor(private googleAuthService: GoogleAuthService,
    private applicantStatusService: ApplicantStatusService
  ) { }

  ngOnInit(): void {
    this.googleAuthService.initClient();
    this.loadEvent();
  }

  ngAfterViewInit(): void {
    setTimeout(function () {
      this.flag = true;
    }, 2000);
  }

  loadEvent() {
    this.isLoading = true;
    this.applicantStatusService.getEventList().subscribe((data: any) => {
      if (data && data.event) {
        try {
          const events = JSON.parse(data.event);
          console.log("Hiiii Calender Data"+events);
          if (Array.isArray(events)) {
            this.events = events.map((event: any) => ({
              title: event.title,
              start: event.start,
              applicantName: event.applicantName,
              end: event.end || null
            }));
          } else {
            this.events = [];
          }
        } catch (e) {
          this.events = [];
        }
      } else {
        console.warn('Event data is not present or invalid:', data);
        this.events = [];
      }
      this.calendarOptions = {
        ...this.calendarOptions,
        events: this.events
      };

      this.isLoading = false;
    }, (error) => {
      this.isLoading = false;
    });
  }
  signIn(): void {
    this.googleAuthService.signIn().then(() => {
      console.log('User signed in');
      this.listUpcomingEvents();
    }).catch(error => {
      console.error('Error signing in', error);
    });
  }

  signOut(): void {
    this.googleAuthService.signOut();
    this.events = [];
    this.calendarOptions = {
      ...this.calendarOptions,
      events: this.events
    };
  }


  listUpcomingEvents(): void {
    this.calendarOptions = {
      ...this.calendarOptions,
      events: this.events
    };
  }

  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    plugins: [
      interactionPlugin,
      dayGridPlugin,
      timeGridPlugin,
      listPlugin,
    ],
    contentHeight: 500,
    aspectRatio: 2,
    dayMaxEvents: true,
    events: this.events,
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,listWeek'
    }
  };
}
